import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Dialog, useTheme } from '@mui/material';
import warning from 'assets/icons/warning.svg';
import { BACKOFFICE_PROD_URL } from 'common/constants';
import { useSelector } from 'react-redux';
import { IStore } from 'v3/data/store';
import { hideErrorDialog } from 'v3/data/store/error/actions';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { Body, Container, Image, Info, PaperStyled, TextAlign, TextAlignColumn, TextGroup } from './styles';

export const BetaAccessError = () => {
  const theme = useTheme();

  const { error } = useSelector((state: IStore) => state.error.betaAccessError);

  const navigateToFinancing = () => {
    window.location.replace(BACKOFFICE_PROD_URL);
  };

  return (
    <Dialog
      onClose={hideErrorDialog}
      open={error}
      fullScreen={true}
      transitionDuration={0}
      PaperComponent={PaperStyled}
    >
      <Container>
        <Body>
          <Image src={warning} alt={'warning'} />
          <HeadlineMedium color={theme.palette.common.white}>Atenção</HeadlineMedium>

          <Info>
            <BodyLarge>Acesso ao BETA não autorizado</BodyLarge>
            <TextAlign>
              <ErrorOutlineIcon />
              <TextAlignColumn>
                <SubtitleLarge>Beta tester, utilize os canais oficiais!</SubtitleLarge>
                <SubtitleLarge>Em breve novidades.</SubtitleLarge>
              </TextAlignColumn>
            </TextAlign>
          </Info>

          <FlexButton
            data-testid="flex-button-try-again"
            text="Ir para o backoffice"
            handleClick={navigateToFinancing}
          />

          <TextGroup>
            <SubtitleLarge>Entre em contato conosco através dos números:</SubtitleLarge>
            <SubtitleLarge>+55 (11) 5196-8374 (WhatsApp).</SubtitleLarge>
          </TextGroup>

          <TextGroup>
            <SubtitleLarge>Horários de atendimento:</SubtitleLarge>
            <SubtitleLarge>Segunda a sábado, das 09 às 21hrs (Horário de Brasília)</SubtitleLarge>
            <SubtitleLarge>Domingo e feriados sem expediente</SubtitleLarge>
          </TextGroup>
        </Body>
      </Container>
    </Dialog>
  );
};
